/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { css } from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  spacing
} from '../../theme';

const roleVariants: {
  [key: string]: {
    bgImage: string | ((key: any) => any);
    cursor: string;
    bgPosition?: string | ((key: any) => any);
    paddingLeft?: string;
    paddingRight?: string;
    borderColor?: string | ((key: any) => any);
  };
} = {
  thousands: {
    bgImage: `url("data:image/svg+xml,%3Csvg width='9' height='10' viewBox='0 0 9 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.53816 0.0879999H1.88216V4.372H1.99416L6.37616 0.0879999H8.25216L3.46416 4.666L8.57416 10H6.61416L1.99416 5.044H1.88216V10H0.53816V0.0879999Z' fill='%23C0BEC9'/%3E%3C/svg%3E%0A")`,
    cursor: 'inherit'
  },
  currency: {
    bgImage: `url("data:image/svg+xml,%3Csvg width='7' height='10' viewBox='0 0 7 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.048 1.692C5.864 1.556 5.636 1.456 5.364 1.392C5.1 1.32 4.804 1.284 4.476 1.284C3.956 1.284 3.504 1.444 3.12 1.764C2.744 2.076 2.468 2.556 2.292 3.204H5.604L5.4 4.008H2.148C2.132 4.144 2.12 4.284 2.112 4.428C2.104 4.572 2.1 4.724 2.1 4.884C2.1 4.988 2.1 5.088 2.1 5.184C2.1 5.28 2.104 5.372 2.112 5.46H5.016L4.812 6.24H2.184C2.288 6.912 2.496 7.416 2.808 7.752C3.128 8.088 3.588 8.256 4.188 8.256C4.524 8.256 4.812 8.192 5.052 8.064C5.3 7.928 5.512 7.756 5.688 7.548L6.276 8.136C6.068 8.416 5.776 8.656 5.4 8.856C5.024 9.048 4.604 9.144 4.14 9.144C3.284 9.144 2.608 8.9 2.112 8.412C1.616 7.916 1.292 7.192 1.14 6.24H0.276L0.504 5.46H1.056C1.048 5.364 1.044 5.268 1.044 5.172C1.044 5.068 1.044 4.96 1.044 4.848C1.044 4.552 1.056 4.272 1.08 4.008H0.288L0.54 3.204H1.224C1.336 2.724 1.496 2.308 1.704 1.956C1.912 1.596 2.16 1.3 2.448 1.068C2.736 0.828 3.052 0.651999 3.396 0.539999C3.748 0.42 4.124 0.36 4.524 0.36C4.86 0.36 5.188 0.4 5.508 0.48C5.828 0.559999 6.092 0.664 6.3 0.792L6.048 1.692Z' fill='%23389C24'/%3E%3C/svg%3E")`,
    cursor: 'inherit',
    bgPosition: 'right 24px top 50%',
    paddingRight: '3rem'
  },
  currencyThousands: {
    bgImage: `url("data:image/svg+xml,%3Csvg width='7' height='10' viewBox='0 0 7 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.048 1.692C5.864 1.556 5.636 1.456 5.364 1.392C5.1 1.32 4.804 1.284 4.476 1.284C3.956 1.284 3.504 1.444 3.12 1.764C2.744 2.076 2.468 2.556 2.292 3.204H5.604L5.4 4.008H2.148C2.132 4.144 2.12 4.284 2.112 4.428C2.104 4.572 2.1 4.724 2.1 4.884C2.1 4.988 2.1 5.088 2.1 5.184C2.1 5.28 2.104 5.372 2.112 5.46H5.016L4.812 6.24H2.184C2.288 6.912 2.496 7.416 2.808 7.752C3.128 8.088 3.588 8.256 4.188 8.256C4.524 8.256 4.812 8.192 5.052 8.064C5.3 7.928 5.512 7.756 5.688 7.548L6.276 8.136C6.068 8.416 5.776 8.656 5.4 8.856C5.024 9.048 4.604 9.144 4.14 9.144C3.284 9.144 2.608 8.9 2.112 8.412C1.616 7.916 1.292 7.192 1.14 6.24H0.276L0.504 5.46H1.056C1.048 5.364 1.044 5.268 1.044 5.172C1.044 5.068 1.044 4.96 1.044 4.848C1.044 4.552 1.056 4.272 1.08 4.008H0.288L0.54 3.204H1.224C1.336 2.724 1.496 2.308 1.704 1.956C1.912 1.596 2.16 1.3 2.448 1.068C2.736 0.828 3.052 0.651999 3.396 0.539999C3.748 0.42 4.124 0.36 4.524 0.36C4.86 0.36 5.188 0.4 5.508 0.48C5.828 0.559999 6.092 0.664 6.3 0.792L6.048 1.692Z' fill='%23389C24'/%3E%3C/svg%3E"), url("data:image/svg+xml,%3Csvg width='7' height='9' viewBox='0 0 7 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.0920001 0.504H1.244V4.176H1.34L5.096 0.504H6.704L2.6 4.428L6.98 9H5.3L1.34 4.752H1.244V9H0.0920001V0.504Z' fill='%23389C24'/%3E%3C/svg%3E")`,
    cursor: 'inherit',
    bgPosition: 'left 24px top 50%, right 24px top 47%',
    paddingLeft: '3rem'
  },
  copy: {
    bgImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.5 0C15.3284 0 16 0.671562 16 1.5V10.5C16 11.3284 15.3284 12 14.5 12H5.5C4.67156 12 4 11.3284 4 10.5V1.5C4 0.671562 4.67156 0 5.5 0H14.5ZM5.5 13C4.1215 13 3 11.8785 3 10.5V4H1.5C0.671562 4 0 4.67156 0 5.5V14.5C0 15.3284 0.671562 16 1.5 16H10.5C11.3284 16 12 15.3284 12 14.5V13H5.5Z' fill='%23C0BEC9'/%3E%3C/svg%3E%0A")`,
    cursor: 'pointer'
  },
  error: {
    bgImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0C3.58065 0 0 3.58065 0 8C0 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8C16 3.58065 12.4194 0 8 0ZM11.9226 10.1C12.0742 10.2516 12.0742 10.4968 11.9226 10.6484L10.6452 11.9226C10.4935 12.0742 10.2484 12.0742 10.0968 11.9226L8 9.80645L5.9 11.9226C5.74839 12.0742 5.50323 12.0742 5.35161 11.9226L4.07742 10.6452C3.92581 10.4935 3.92581 10.2484 4.07742 10.0968L6.19355 8L4.07742 5.9C3.92581 5.74839 3.92581 5.50323 4.07742 5.35161L5.35484 4.07419C5.50645 3.92258 5.75161 3.92258 5.90323 4.07419L8 6.19355L10.1 4.07742C10.2516 3.92581 10.4968 3.92581 10.6484 4.07742L11.9258 5.35484C12.0774 5.50645 12.0774 5.75161 11.9258 5.90323L9.80645 8L11.9226 10.1Z' fill='%23DE492B'/%3E%3C/svg%3E%0A")`,
    cursor: 'inherit',
    borderColor: color('negative_700'),
    paddingRight: '3rem'
  },
  success: {
    bgImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 8C16 12.4183 12.4183 16 8 16C3.58171 16 0 12.4183 0 8C0 3.58171 3.58171 0 8 0C12.4183 0 16 3.58171 16 8ZM7.07464 12.2359L13.0101 6.30045C13.2117 6.0989 13.2117 5.7721 13.0101 5.57055L12.2802 4.84064C12.0787 4.63906 11.7519 4.63906 11.5503 4.84064L6.70968 9.68123L4.44971 7.42126C4.24816 7.21971 3.92135 7.21971 3.71977 7.42126L2.98987 8.15116C2.78832 8.35271 2.78832 8.67952 2.98987 8.88106L6.34471 12.2359C6.54629 12.4375 6.87306 12.4375 7.07464 12.2359Z' fill='%2378D549'/%3E%3C/svg%3E%0A")`,
    cursor: 'inherit',
    paddingRight: '3rem'
  },
  loading: {
    bgImage: `url("data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' viewBox='0 -256 1792 1792' id='svg3025' version='1.1' inkscape:version='0.48.3.1 r9886' width='16' height='16' sodipodi:docname='spinner_font_awesome.svg'%3E%3Cmetadata id='metadata3035'%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=''%3E%3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E%3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cdefs id='defs3033' /%3E%3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='640' inkscape:window-height='480' id='namedview3031' showgrid='false' inkscape:zoom='0.13169643' inkscape:cx='896' inkscape:cy='896' inkscape:window-x='0' inkscape:window-y='25' inkscape:window-maximized='0' inkscape:current-layer='svg3025' /%3E%3Cg transform='matrix(1,0,0,-1,121.49153,1315.7966)' id='g3027'%3E%3Cpath d='M 496,192 Q 496,132 453.5,90 411,48 352,48 q -60,0 -102,42 -42,42 -42,102 0,60 42,102 42,42 102,42 59,0 101.5,-42 Q 496,252 496,192 z M 928,0 Q 928,-53 890.5,-90.5 853,-128 800,-128 747,-128 709.5,-90.5 672,-53 672,0 672,53 709.5,90.5 747,128 800,128 853,128 890.5,90.5 928,53 928,0 z M 320,640 Q 320,574 273,527 226,480 160,480 94,480 47,527 0,574 0,640 q 0,66 47,113 47,47 113,47 66,0 113,-47 47,-47 47,-113 z M 1360,192 q 0,-46 -33,-79 -33,-33 -79,-33 -46,0 -79,33 -33,33 -33,79 0,46 33,79 33,33 79,33 46,0 79,-33 33,-33 33,-79 z M 528,1088 Q 528,1015 476.5,963.5 425,912 352,912 279,912 227.5,963.5 176,1015 176,1088 q 0,73 51.5,124.5 51.5,51.5 124.5,51.5 73,0 124.5,-51.5 Q 528,1161 528,1088 z m 464,192 q 0,-80 -56,-136 -56,-56 -136,-56 -80,0 -136,56 -56,56 -56,136 0,80 56,136 56,56 136,56 80,0 136,-56 56,-56 56,-136 z m 544,-640 q 0,-40 -28,-68 -28,-28 -68,-28 -40,0 -68,28 -28,28 -28,68 0,40 28,68 28,28 68,28 40,0 68,-28 28,-28 28,-68 z m -208,448 q 0,-33 -23.5,-56.5 -23.5,-23.5 -56.5,-23.5 -33,0 -56.5,23.5 -23.5,23.5 -23.5,56.5 0,33 23.5,56.5 23.5,23.5 56.5,23.5 33,0 56.5,-23.5 23.5,-23.5 23.5,-56.5 z' id='path3029' inkscape:connector-curvature='0' style='fill:%23ccc' /%3E%3C/g%3E%3C/svg%3E")`,
    cursor: 'inherit',
    paddingRight: '3rem'
  },
  linkedin: {
    bgImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.8571 0H1.13929C0.510714 0 0 0.517857 0 1.15357V14.8464C0 15.4821 0.510714 16 1.13929 16H14.8571C15.4857 16 16 15.4821 16 14.8464V1.15357C16 0.517857 15.4857 0 14.8571 0ZM4.83571 13.7143H2.46429V6.07857H4.83929V13.7143H4.83571ZM3.65 5.03571C2.88929 5.03571 2.275 4.41786 2.275 3.66071C2.275 2.90357 2.88929 2.28571 3.65 2.28571C4.40714 2.28571 5.025 2.90357 5.025 3.66071C5.025 4.42143 4.41071 5.03571 3.65 5.03571ZM13.725 13.7143H11.3536V10C11.3536 9.11429 11.3357 7.975 10.1214 7.975C8.88571 7.975 8.69643 8.93929 8.69643 9.93571V13.7143H6.325V6.07857H8.6V7.12143H8.63214C8.95 6.52143 9.725 5.88929 10.8786 5.88929C13.2786 5.88929 13.725 7.47143 13.725 9.52857V13.7143Z' fill='%23C0BEC9'/%3E%3C/svg%3E%0A"), linear-gradient(to right, transparent 56px, #DEDCE4 56px, #DEDCE4 58px, transparent 58px)`,
    cursor: 'inherit',
    paddingLeft: '5rem',
    paddingRight: '1.25rem',
    bgPosition: 'left 20px top 50%, left center'
  },
  linkedinError: {
    bgImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.8571 0H1.13929C0.510714 0 0 0.517857 0 1.15357V14.8464C0 15.4821 0.510714 16 1.13929 16H14.8571C15.4857 16 16 15.4821 16 14.8464V1.15357C16 0.517857 15.4857 0 14.8571 0ZM4.83571 13.7143H2.46429V6.07857H4.83929V13.7143H4.83571ZM3.65 5.03571C2.88929 5.03571 2.275 4.41786 2.275 3.66071C2.275 2.90357 2.88929 2.28571 3.65 2.28571C4.40714 2.28571 5.025 2.90357 5.025 3.66071C5.025 4.42143 4.41071 5.03571 3.65 5.03571ZM13.725 13.7143H11.3536V10C11.3536 9.11429 11.3357 7.975 10.1214 7.975C8.88571 7.975 8.69643 8.93929 8.69643 9.93571V13.7143H6.325V6.07857H8.6V7.12143H8.63214C8.95 6.52143 9.725 5.88929 10.8786 5.88929C13.2786 5.88929 13.725 7.47143 13.725 9.52857V13.7143Z' fill='%23DE492B'/%3E%3C/svg%3E%0A"), linear-gradient(to right, transparent 56px, #DE492B 56px, #DE492B 58px, transparent 58px), url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0C3.58065 0 0 3.58065 0 8C0 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8C16 3.58065 12.4194 0 8 0ZM11.9226 10.1C12.0742 10.2516 12.0742 10.4968 11.9226 10.6484L10.6452 11.9226C10.4935 12.0742 10.2484 12.0742 10.0968 11.9226L8 9.80645L5.9 11.9226C5.74839 12.0742 5.50323 12.0742 5.35161 11.9226L4.07742 10.6452C3.92581 10.4935 3.92581 10.2484 4.07742 10.0968L6.19355 8L4.07742 5.9C3.92581 5.74839 3.92581 5.50323 4.07742 5.35161L5.35484 4.07419C5.50645 3.92258 5.75161 3.92258 5.90323 4.07419L8 6.19355L10.1 4.07742C10.2516 3.92581 10.4968 3.92581 10.6484 4.07742L11.9258 5.35484C12.0774 5.50645 12.0774 5.75161 11.9258 5.90323L9.80645 8L11.9226 10.1Z' fill='%23DE492B'/%3E%3C/svg%3E%0A")`,
    borderColor: '#DE492B',
    cursor: 'inherit',
    paddingLeft: '5rem',
    paddingRight: '3rem',
    bgPosition: 'left 20px top 50%, left center, right 20px center'
  },
  search: {
    bgImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='l6' height='16' fill='none' viewBox='0 0 512 512'%3E%3Cpath d='M504.1 471l-134-134C399.1 301.5 415.1 256.8 415.1 208c0-114.9-93.13-208-208-208S-.0002 93.13-.0002 208S93.12 416 207.1 416c48.79 0 93.55-16.91 129-45.04l134 134C475.7 509.7 481.9 512 488 512s12.28-2.344 16.97-7.031C514.3 495.6 514.3 480.4 504.1 471zM48 208c0-88.22 71.78-160 160-160s160 71.78 160 160s-71.78 160-160 160S48 296.2 48 208z' fill='%23C0BEC9'/%3E%3C/svg%3E")`,
    cursor: 'inherit',
    paddingLeft: '2.5rem',
    bgPosition: 'left 12px top 50%'
  }
};

const sizeVariants: {
  [key: string]: {
    padding?: string | ((key: any) => string);
    fontSize?: string | ((key: any) => string);
    height?: string;
  };
} = {
  sm: {
    padding: spacing('sm'),
    fontSize: fontSize('xs'),
    height: '2.5rem'
  }
};

export const StyledInputTextWrapper = styled.div`
  position: relative;
`;

export const StyledButton = styled.button`
  position: absolute;
  border: none;
  appearance: none;
  background: transparent;
  color: ${color('midnight_300')};
  bottom: 0.8rem;
  right: 1rem;
  height: 1.5rem;
`;

export const StyledInputText = styled.input<{
  variant?: string;
  sizes?: string;
  disabled?: boolean;
}>`
  width: 100%;
  min-width: ${spacing('xl7')};
  height: 3.5rem;
  padding: 1.25rem;
  font-family: ${fontFamily('sans')};
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('medium')};
  color: ${color('text_default')};
  border-radius: ${radius('md')};
  border: 2px solid ${color('midnight_200')};
  transition: 0.3s;
  appearance: none;
  background-color: ${color('white')} !important;

  &.with-specific-size {
    width: auto;
    min-width: auto;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:focus {
    transition: background-color 600000s 0s, color 600000s 0s;
  }

  ${({ variant }) =>
    variant &&
    roleVariants[variant] &&
    css`
      padding-right: 3rem;
      background-image: ${roleVariants[variant].bgImage} !important;
      background-repeat: no-repeat;
      background-position: right ${spacing('lg')} top 50%;
      cursor: ${roleVariants[variant].cursor};
      background-position: ${roleVariants[variant].bgPosition};
      padding-left: ${roleVariants[variant].paddingLeft} !important;
      padding-right: ${roleVariants[variant].paddingRight} !important;
      border-color: ${roleVariants[variant].borderColor} !important;
    `}

  ${({ sizes }) =>
    sizes &&
    sizeVariants[sizes] &&
    css`
      padding: ${sizeVariants[sizes].padding};
      font-size: ${sizeVariants[sizes].fontSize};
      height: ${sizeVariants[sizes].height};
    `}

    ${({ sizes, variant }) =>
    sizes === 'sm' &&
    variant === 'currencyThousands' &&
    css`
      background-position: left 12px top 50%, right 12px top 47%;
      padding-left: ${spacing('lg')} !important;
      padding-right: ${spacing('lg')};
    `}

    ${({ variant }) =>
    variant &&
    roleVariants[variant] &&
    roleVariants[variant].paddingRight &&
    css`
      padding-right: ${roleVariants[variant].paddingRight};
    `}

  &::placeholder {
    color: ${color('text_placeholder')};
  }

  &:hover {
    border-color: ${color('midnight_400')};
  }

  &:focus {
    outline: 0;
    border-color: ${color('midnight_850')};
    box-shadow: 0 0 0 4px ${color('midnight_150')};
  }

  &-ms-reveral {
    border: 1px solid transparent;
    border-radius: 50%;
    box-shadow: 0 0 3px surrentColor;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      background-color: ${color('midnight_150')};
      border-color: ${color('midnight_200')};
      color: ${color('text_disabled')};
    `}
`;
